import script from "./PopularDishCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopularDishCard.vue?vue&type=script&setup=true&lang=ts"

import "./PopularDishCard.vue?vue&type=style&index=0&id=586e9428&lang=scss"

const __exports__ = script;

export default __exports__